// Raise maxStorageBuffersPerShaderStage to >= 10 on EVERY WebGPU device the page
// creates. HEADROOM, no longer a requirement: the GpuLifter's pass1 binds 8 — exactly
// the WebGPU default — since `valid` was folded into triim, so a stock ORT device now
// qualifies to be shared with the lifter on its own. It bound 9 before that fold, and
// this patch was the only reason geom_uv/color_uv weren't taking a per-frame
// GPU->CPU->GPU round-trip (own-device lift path) on every machine.
//
// ORT-Web caches its device on the FIRST webgpu session create — which, in this
// app, can be the hair spec_mod OR the Isaac geom/appr decoders, whichever loads
// first. A later patch (e.g. inside setupSharedOrtAdapter) is too late: the device
// already exists at limit 8. So this patches GPUAdapter.prototype.requestDevice at
// app boot, BEFORE any session is created — hence the side-effect import at the top
// of main.jsx. ORT-Web 1.26's `ort.env.webgpu.adapter` is read-only, so handing ORT
// a pre-built adapter isn't an option; patching the prototype is.
//
// Additive only: it RAISES maxStorageBuffersPerShaderStage (never lowers) and, under
// ?perf=1, adds timestamp-query when the adapter supports it (lets the GpuLifter time
// pass1->pass2). Harmless to other WebGPU consumers; Spark renders on WebGL.

const WANT = 10;

export function installWebGpuLimitPatch() {
  if (typeof GPUAdapter === 'undefined' || !GPUAdapter.prototype) return;
  if (GPUAdapter.prototype.__aosLimitsPatched) return;
  const orig = GPUAdapter.prototype.requestDevice;
  if (typeof orig !== 'function') return;
  const wantPerf = typeof location !== 'undefined' && /[?&]perf=1/.test(location.search);
  GPUAdapter.prototype.requestDevice = function requestDevice(descriptor = {}) {
    const adapterMax = this.limits?.maxStorageBuffersPerShaderStage ?? 8;
    const want = Math.min(WANT, adapterMax);
    const requiredLimits = { ...(descriptor.requiredLimits || {}) };
    requiredLimits.maxStorageBuffersPerShaderStage = Math.max(
      requiredLimits.maxStorageBuffersPerShaderStage ?? 0,
      want,
    );
    let requiredFeatures = descriptor.requiredFeatures;
    if (wantPerf && this.features?.has?.('timestamp-query')
        && !(requiredFeatures && [...requiredFeatures].includes('timestamp-query'))) {
      requiredFeatures = [...(requiredFeatures ?? []), 'timestamp-query'];
    }
    return orig.call(this, { ...descriptor, requiredLimits, requiredFeatures });
  };
  GPUAdapter.prototype.__aosLimitsPatched = true;
}

installWebGpuLimitPatch();
